export const MICRO_NAME = 'micro-hiro';

export const MICRO_URL = `${process.env['VUE_APP_MF_HIRO']}`;